<span class="link-icon" tabindex="0" (gtwClickOutside)="isShowing = false">
    <span class="link-icon-trigger" (click)="isShowing = !isShowing"
        ap-tooltip [tooltipContent]="'External Apps'" [direction]="'bottom-left'" [tooltipId]="'header-external-apps'" ariaDescribedby="header-external-apps">
        <span class="Appkit4-icon icon-grid-view-outline"></span>
        <span class="a-icon Appkit4-icon icon-down-chevron-fill dropIcon"></span>
    </span>
    <div class="ext-apps-dropdown" [class.show]="isShowing">
        <div class="ext-apps-header">External Apps</div>
        <div class="ext-apps-list">
            @for (app of externalAppList || []; track $index) {
<div class="ext-apps-item" (click)="openApp(app.app_url)">
                <span class="Appkit4-icon icon-link-outline ext-apps-item-icon"></span>
                <span class="ext-apps-item-label">{{app.app_name}}</span>
            </div>
}
            @if ((externalAppList?.length ?? 0) === 0) {
<div class="ext-apps-empty">
                <i>No external application listed.</i>
            </div>
}
        </div>
    </div>
</span>
